import { render, staticRenderFns } from "./complaintConfirm.vue?vue&type=template&id=2b18b392&"
import script from "./complaintConfirm.vue?vue&type=script&lang=js&"
export * from "./complaintConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports